export default "__VITE_ASSET__CuhEmUBB__"